import { render, staticRenderFns } from "./SearchPage.vue?vue&type=template&id=fb56ee0c&scoped=true"
import script from "./SearchPage.vue?vue&type=script&lang=js"
export * from "./SearchPage.vue?vue&type=script&lang=js"
import style0 from "./SearchPage.vue?vue&type=style&index=0&id=fb56ee0c&prod&scoped=true&lang=scss"
import style1 from "./SearchPage.vue?vue&type=style&index=1&id=fb56ee0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb56ee0c",
  null
  
)

export default component.exports